import { observable, action, makeObservable } from 'mobx'
import RootStore from './Root'
import { uploadTransactionCSV, getUploadCsvLogs, calculateEarnings } from '../api/StickyIoImportTransaction'

interface csvLog {
    _id: string
    file_name: string
    uploaded_by: string
    createdAt: string
    updatedAt: string
    status?: string
    current_stage?: string
    row_count?: number
    processed_row_count?: number
    error_code?: string
}

class StickyIoTransactionImportStore {
    public rootStore: RootStore
    @observable public isApiError: boolean
    @observable public isUploading: boolean
    @observable public isCalculating: boolean
    @observable public logData: Array<csvLog>
    @observable public currentPage: number
    @observable public totalPage: number
    @observable public limit: number
    @observable public totalRows: number
    @observable public awsUrl: string

    constructor(rootStore: RootStore) {
        makeObservable(this)
        this.rootStore = rootStore
        this.isApiError = false
        this.isUploading = false
        this.isCalculating = false
        this.logData = []
        this.currentPage = 1
        this.totalPage = 0
        this.limit = 0
        this.totalRows = 0
        this.awsUrl = ''
    }

    @action.bound
    uploadCSV(data: FormData) {
        this.isApiError = false
        this.isUploading = true
        uploadTransactionCSV(data).then((response) => {
            if (response.data.status === false) {
                this.isUploading = false
                this.isApiError = true
                alert(response.data.message)
                return
            }
            this.isUploading = response.data?.data?.status === 'processing'
            this.getCsvLog(1)
            alert(response.data.message)
            return
        }).catch((error) => {
            this.isApiError = true
            this.getCsvLog(1)
            alert(error?.response?.data?.message || 'The connection ended before a final response. The import log is being checked for the actual status.')
        })
    }

    @action.bound
    getCsvLog(currentPage: number): void {
        getUploadCsvLogs(currentPage).then((response) => {
            if (response.data.success === false) {
                this.isApiError = true
                alert(response.data.message)
                return
            }
            const responseData = response.data
            this.logData = responseData.data.rows
            this.isUploading = this.logData.some((row) => row.status === 'processing')
            this.currentPage = responseData.data.currentPage
            this.totalPage = responseData.data.totalPages
            this.limit = responseData.data.limit
            this.totalRows = responseData.data.totalRows
            this.isApiError = false
            this.awsUrl = responseData.data.awsUrl
            return
        }).catch((error) => {
            this.isApiError = true
            alert(error?.response?.data?.message || 'Import logs could not be loaded.')
        })
    }

    @action.bound
    calculateEarning(data: { date: string }) {
        this.isApiError = false
        this.isCalculating = true
        calculateEarnings(data).then((response) => {
            this.isCalculating = false
            if (response.data.status === false) {
                this.isApiError = true
                alert(response.data.message)
                return
            }
            this.getCsvLog(1)
            alert(response.data.message)
            return
        }).catch((error) => {
            this.isCalculating = false
            this.isApiError = true
            alert(error?.response?.data?.message || 'Earnings could not be calculated.')
        })
    }
}

export default StickyIoTransactionImportStore
